import { ROUTES } from '../../routes/consts';
import { StepConfig } from '../../shared/MultiStepDialog';
import { spawn } from '../../utils/translations';
import { STEP_IDS, FORM_IDS } from './consts';
import { CarouselStepConfig } from './types';
import installGuideSelectOrg from '/images/github-installation/install-guide-select-org.png';
import installGuideSelectRepos from '/images/github-installation/install-guide-select-repos.png';

const spawnSteps = spawn('dialogs.github-mt-installation.steps');

export const getSteps = ({
  isErrorResultStep,
}: {
  isErrorResultStep: boolean;
}): StepConfig[] => {
  return [
    {
      id: STEP_IDS.INSTALL_GUIDE,
      path: ROUTES.GITHUB_MT_INSTALLATION_STEP_1,
      title: spawnSteps('install-guide.title'),
      shouldShowBackButton: false,
      shouldShowCancelButton: true,
      nextLabel: spawnSteps('install-guide.next-label'),
      formId: FORM_IDS.INSTALL_GUIDE,
    },
    {
      id: STEP_IDS.INSTALLATION_COMPLETE,
      path: ROUTES.GITHUB_MT_INSTALLATION_STEP_2,
      title: isErrorResultStep
        ? spawnSteps('installation-complete.error-title')
        : spawnSteps('installation-complete.title'),
      shouldShowBackButton: false,
      nextLabel: isErrorResultStep
        ? spawnSteps('installation-complete.close-label')
        : spawnSteps('installation-complete.next-label'),
      isNextInitiallyEnabled: false,
    },
  ];
};

export const INSTALL_GUIDE_CAROUSEL_STEPS: CarouselStepConfig[] = [
  { id: 'select-org', image: installGuideSelectOrg },
  { id: 'select-repositories', image: installGuideSelectRepos },
];
